// extracted by mini-css-extract-plugin
module.exports = {"inputFilter":"voucherStateTable_inputFilter__3Hk4Z","containerTable":"voucherStateTable_containerTable__PmExu"};